import { render, staticRenderFns } from "./LogCard.vue?vue&type=template&id=42dc76f5&"
import script from "./LogCard.vue?vue&type=script&lang=js&"
export * from "./LogCard.vue?vue&type=script&lang=js&"
import style0 from "./LogCard.vue?vue&type=style&index=0&id=42dc76f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports